import React from "react";

import { useFormikContext } from "formik";

import { Form, Grid } from "semantic-ui-react";

function BatchMetaInput() {
	const { values, handleChange, errors, touched } = useFormikContext();
	return (
		<Grid columns={2} style={{ marginBottom: "0px" }}>
			<Grid.Column>
				<Form.Input
					fluid
					label="Buyer"
					placeholder="A person or a company"
					name="buyer"
					value={values.buyer}
					onChange={handleChange}
				/>
				<p style={{ color: "red" }}>
					{errors.buyer && touched.buyer && errors.buyer}
				</p>
			</Grid.Column>
			<Grid.Column>
				<Form.Input
					fluid
					label="Invoice Number"
					placeholder="XXXXX-XXX"
					name="invoiceNo"
					value={values.invoiceNo}
					onChange={handleChange}
				/>
				<p style={{ color: "red" }}>
					{errors.invoiceNo && touched.invoiceNo && errors.invoiceNo}
				</p>
			</Grid.Column>
		</Grid>
	);
}

export default BatchMetaInput;
